import React from 'react';

import { useSearch } from '../../../../hooks/context';
import FilterSort from '../../../../components-v2/filters/filter-sort';
import { MapButtonDesktop } from '../../../../components-v2/sidebar/components/map';

const namespace = 'ui-search-toolbar-options-map';

const ToolbarOptions = () => {
  const contextValues = useSearch();
  const {
    view_options: { sort },
  } = contextValues;

  return (
    <div className={namespace}>
      <div className={`${namespace}__sort`}>
        <FilterSort
          {...sort}
          renderCustomTrigger={(currentValue) => <span className={`${namespace}__sort-value`}>{currentValue}</span>}
        />
      </div>
      <MapButtonDesktop {...contextValues.map_link} />
    </div>
  );
};

export { ToolbarOptions };
